export class RouteSegment {
    constructor(condition, valuef, group, points = 1) {
        this.value = condition ? valuef() : '';
        this.group = group;
        this.points = condition ? points : 0;
    }

    isRouteSegment = () => true;

    hasValue = () => {
        return this.value !== '';
    }

    static getSegmentWhen(condition, valuef, group, points = 1) {
        return new RouteSegment(condition, valuef, group, points);
    }

    static getSegment(valuef, group, points = 1) {
        return new RouteSegment(true, valuef, group, points);
    }
}
